import * as yup from 'yup';
import { useTranslations } from 'hooks/useTranslations';

const useDocumentFormSchema = () => {
  const { t } = useTranslations();
  const schema = yup.object({
    typeUniqueId: yup.string().required(t('general.field.validation.required')),
    importantNotice: yup
      .string()
      .required(t('general.field.validation.required'))
      .max(255, t('general.field.validation.maxCharacters').replace('{0}', '255'))
      .trim(),
  });
  return { schema };
};
export default useDocumentFormSchema;
